var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded && _vm.project)?_c('div',{staticClass:"editor select-none"},[_c('router-view'),_c('new-section-modal'),_c('new-link-modal'),_c('new-page-modal'),_c('custom-modal'),_c('injection-page-modal')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }